@let _pulseSurvey = pulseSurvey(); @if (_pulseSurvey) {
<div class="survey-details">
	<h5>
		{{ _pulseSurvey.testName | translate }}
		{{ _pulseSurvey.Value.Value }}
		/{{ _pulseSurvey.maxScore }}
	</h5>

	<div class="mb-4">
		<div class="col-12 text-center">
			<div class="d-flex flex-column score-wrapper">
				<div class="scores d-flex">
					@for (score of _pulseSurvey.scoring; track score.color) {
					<div
						class="score-box"
						[ngStyle]="{
                  'background-color': score.color,
                  flex: score.endScore - score.startScore,
                }"
					></div>
					}
				</div>
				<div class="score-wrapper-line">
					<div
						class="current-score"
						[style.left]="
              (_pulseSurvey.Value.Value / _pulseSurvey.maxScore) * 100 + '%'
            "
					>
						<div class="current-score-text">{{ "current" | translate }}</div>
						<div
							class="current-score-circle"
							[ngStyle]="{ 'border-color': score().color }"
						></div>
						<div class="current-score-bar"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="mb-3">
		<div class="text-center">
			<p class="mb-0">{{ "this_score_suggests" | translate }}</p>
			<h4>{{ score().name | translate }}</h4>
		</div>
	</div>
	<div>
		<div class="col-12 d-flex justify-content-center">
			<button
				class="btn btn-primary btn-option"
				[routerLink]="['/pulse-survey/' + pulseSurveyId() + '/result']"
			>
				{{ "how_to_interpret_your_score" | translate }}
				<img
					src="../../../assets/images/icons/chevron-right.svg"
					alt=""
					class="filter-white"
				>
			</button>
		</div>
	</div>
</div>
@if (score().showHealthCounseling && hasCounsellingAccess()) {
<app-card
	class="dark"
	[image]="'counselling' | image : 'jpg'"
	[title]="'health-counselling.title' | translate"
	[description]="'health-counselling.description' | translate"
	[routerLink]="['/counselling']"
/>
} @let _services = services(); @if (score().showServices && _services?.length) {
<div class="d-flex flex-column gap-1">
	<h4 class="fw-bold mb-0 header">
		{{ "common.your-included-services" | translate }}
	</h4>
	<app-carousel>
		@for (service of _services; track service.id) {
		<ng-template appCarouselItem>
			<app-card
				[image]="service.HeroLogo"
				[title]="service.HealthService.Name"
				[description]="service.Contact"
				[routerLink]="['/library', 'service', service.Id.toString()]"
			/>
		</ng-template>
		}
	</app-carousel>
</div>
} @let _videos = videos() | async; @if (_videos?.length) {
<div class="d-flex flex-column gap-1">
	<h4 class="fw-bold mb-0 header">{{ "common.inspiration" | translate }}</h4>
	<app-carousel>
		@for (video of _videos; track video.VideoId) {
		<ng-template appCarouselItem>
			<app-card
				[image]="video.Thumbnail"
				[title]="video.TitleTranslation"
				[description]="video.VideoTranslation"
				[details]="video.Duration + ' ' + ('common.minutes' | translate)"
				[icon]="'play'"
				[showFavoriteButton]="true"
				[isFavorite]="isFavoriteVideo(video.VideoId)"
				(cardClick)="openVideo(video)"
				(favoriteToggle)="toggleFavoriteVideo(video.VideoId)"
			/>
		</ng-template>
		}
	</app-carousel>
</div>
} @let _historicPulseSurveys = historicPulseSurveys(); @if
(_historicPulseSurveys?.length) {
<h4>{{ _pulseSurvey.name | translate }} {{ "reports" | translate }}</h4>

<div class="d-flex flex-column gap-1">
	@for (survey of _historicPulseSurveys; track survey.SurveyId.Value) {
	<app-report-card
		[title]="'Personal_Report' | translate"
		[subtitle]="survey.CreatedDate.Value.Iso | date : 'dd.MM.yyyy'"
		[showDownload]="false"
		[showDelete]="false"
		(viewReport)="viewReport(survey.SurveyId.Value)"
	/>
	}
</div>
} }
